import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import M_NavBar from "../../../Molecules/Common/Navigations/M_NavBar";
import M_MainDrawer from "../../../Molecules/Common/Navigations/M_MainDrawer";
import M_SearchResult from "../../../Molecules/Common/Renderers/Views/GlobalSearchRenderers/M_SearchResult";
import { debounce } from "lodash";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { navigationEnums } from "./O_Navigation.Helper";
// import { flushBreadCrumps } from "../../../Molecules/Common/PageHeaders/TemplatePageTitle/M_BreadCrumbs.helper";
import { useDispatch } from "react-redux";
import { portfolioapproval } from "../../../Molecules/Common/PageHeaders/Toolbar/M_ToolbarFilterhelper";
import { resetFiltersValue } from "../../../../../store/actions/manageFilterValueAction";
const O_Navigation = (props) => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [iconClicked, setIconClicked] = useState(false);
  const [openSearchResult, setOpenSearchResult] = useState(false);
  const [searchValue, setSearchValue] = useState(null);
  let history = useHistory();
  // eslint-disable-next-line no-use-before-define, no-unused-vars
  const [currentPathName, setCurrentPathName] = useState(
    localStorage.getItem(portfolioapproval.CURRENTPATHNAME)
      ? localStorage.getItem(portfolioapproval.CURRENTPATHNAME)
      : ""
  );
  //handle main-Drawer open/close event.
  const handleDrawer = (isIconClicked = false) => {
    setOpenDrawer(!openDrawer);
    setIconClicked(false);
    if (isIconClicked) {
      setIconClicked(true);
    }
  };

  const handleSearchDebounce = React.useCallback(
    debounce((e) => {
      setSearchValue(e);
    }, 500),
    []
  );

  const handleSearchBox = (e) => {
    if (e.target.value && e.target.value.length > 0) {
      setOpenSearchResult(true);
      handleSearchDebounce(e.target.value.trim());
    } else if (openSearchResult) {
      setOpenSearchResult(false);
      setSearchValue(null);
    }
  };
  function getFirstPathSegment() {
    if (
      typeof window === "undefined" ||
      !window.location ||
      !window.location.pathname
    ) {
      return null;
    }
    const pathSegments = window.location.pathname.split("/").filter(Boolean);
    return pathSegments.length >= 2 ? pathSegments[1] : null;
  }

  const handleClick = (e) => {
    const { id, pageId, pageUrl } = e;
    const templateString = localStorage.getItem(
      navigationEnums.SEARCH_TEMPLATE_NEWDATA
    )
      ? localStorage.getItem(navigationEnums.SEARCH_TEMPLATE_NEWDATA)
      : "[]";
    let templates = [];
    try {
      templates = JSON.parse(templateString);
    } catch (e) {
      templates = [];
    }
    const requiredTemplate = Array.isArray(templates)
      ? templates.filter((template) => template.label === pageUrl)
      : [];
    const templateId =
      requiredTemplate.length > 0 && requiredTemplate[0].templateId
        ? requiredTemplate[0].templateId
        : "";
    let crmIdValue = id;
    let pageIdValue = pageId;
    let pageUrlValue = pageUrl;
    let crmId = getFirstPathSegment();

    if (!pageIdValue || !crmIdValue || !pageUrlValue) {
      return;
    }
    if (crmIdValue === crmId) {
      setTimeout(location.reload.bind(location), 50);
      return;
    }
    let url = "/" + pageUrlValue + "/" + crmIdValue + "/" + templateId;
    setOpenSearchResult(false);
    setSearchValue(null);
    history.push(url);
    // flushBreadCrumps();
  };
  const dispatch = useDispatch();
  useEffect(() => {
    var pathname = window.location.pathname;
    var parts = pathname.split("/");
    if (parts.length > 1) {
      if (currentPathName !== parts[1] && currentPathName !== "") {
        dispatch(resetFiltersValue());
      } else localStorage.removeItem("chartStorageKeys");
      localStorage.setItem(portfolioapproval.CURRENTPATHNAME, parts[1]);
    }
  }, [currentPathName]);
  useEffect(() => {
    function handleClickOutside(event) {
      let selectSearchElement = document.getElementById(
        navigationEnums.GLOBAL_SEARCH
      );
      let selectSearchScrollView = document.getElementById(
        navigationEnums.SEARCH_SCROLL_VIEW
      );
      let selectSearchFullView = document.getElementById(
        navigationEnums.SEARCH_FULL_VIEW
      );
      if (selectSearchElement && !selectSearchElement.contains(event.target)) {
        if (
          selectSearchScrollView !== null &&
          selectSearchScrollView.contains(event.target)
        ) {
          return;
        } else if (
          selectSearchFullView !== null &&
          selectSearchFullView.contains(event.target)
        ) {
          return;
        } else {
          setOpenSearchResult(false);
        }
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <React.Fragment>
      <M_NavBar
        defaultValue={searchValue}
        {...props}
        handleDrawer={(e) => handleDrawer(e)}
        onChange={handleSearchBox}
      />

      <M_MainDrawer
        openDrawer={openDrawer}
        user={props.user}
        handleDrawer={(e) => handleDrawer(e)}
        iconClicked={iconClicked}
      />
      {openSearchResult && searchValue && searchValue.length > 1 ? (
        <M_SearchResult
          user={props.user}
          searchKey={searchValue}
          handleClick={handleClick}
        />
      ) : (
        ""
      )}
    </React.Fragment>
  );
};

O_Navigation.propTypes = {
  user: PropTypes.object,
};

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps)(O_Navigation);
